export const MANAGERS = [
  {
    key: "skills",
    title: "مهارت‌ها",
    singular: "مهارت",
    icon: "Sparkles",
    labelField: "name",
    columns: ["name", "category", "percentage"],
    fields: [
      { name: "name", label: "نام مهارت", type: "text", required: true },
      { name: "percentage", label: "درصد تسلط", type: "number", min: 0, max: 100, default: 80 },
      { name: "category", label: "دسته‌بندی", type: "text" },
      { name: "color", label: "رنگ", type: "color", default: "#7877C6" },
      { name: "icon", label: "آیکون", type: "icon" },
      { name: "description", label: "توضیحات", type: "textarea" },
      { name: "featured", label: "ویژه", type: "boolean" },
    ],
  },
  {
    key: "experience",
    title: "تجربیات کاری",
    singular: "تجربه",
    icon: "Briefcase",
    labelField: "title",
    columns: ["title", "company", "startDate"],
    fields: [
      { name: "title", label: "عنوان شغلی", type: "text", required: true },
      { name: "company", label: "شرکت / مجموعه", type: "text" },
      { name: "description", label: "توضیحات", type: "textarea" },
      { name: "startDate", label: "تاریخ شروع", type: "text" },
      { name: "endDate", label: "تاریخ پایان", type: "text" },
      { name: "current", label: "شغل فعلی", type: "boolean" },
      { name: "icon", label: "آیکون", type: "icon" },
    ],
  },
  {
    key: "projects",
    title: "پروژه‌ها",
    singular: "پروژه",
    icon: "FolderOpen",
    labelField: "title",
    columns: ["title", "featured"],
    fields: [
      { name: "title", label: "عنوان", type: "text", required: true },
      { name: "description", label: "توضیحات", type: "textarea" },
      { name: "thumbnail", label: "تصویر شاخص", type: "media" },
      { name: "gallery", label: "گالری تصاویر", type: "gallery" },
      { name: "technologies", label: "تکنولوژی‌ها", type: "tags" },
      { name: "demoLink", label: "لینک دمو", type: "text" },
      { name: "purchaseLink", label: "لینک خرید", type: "text" },
      { name: "repoLink", label: "لینک مخزن", type: "text" },
      { name: "featured", label: "ویژه", type: "boolean" },
    ],
  },
  {
    key: "portfolio",
    title: "نمونه‌کارها",
    singular: "نمونه‌کار",
    icon: "Image",
    labelField: "title",
    columns: ["title", "category"],
    fields: [
      { name: "title", label: "عنوان", type: "text", required: true },
      { name: "description", label: "توضیحات", type: "textarea" },
      { name: "image", label: "تصویر", type: "media" },
      { name: "category", label: "دسته‌بندی", type: "text" },
      { name: "tags", label: "برچسب‌ها", type: "tags" },
      { name: "link", label: "لینک", type: "text" },
      { name: "featured", label: "ویژه", type: "boolean" },
    ],
  },
  {
    key: "certificates",
    title: "مدارک",
    singular: "مدرک",
    icon: "Award",
    labelField: "title",
    columns: ["title", "organization", "issueDate"],
    fields: [
      { name: "title", label: "عنوان مدرک", type: "text", required: true },
      { name: "organization", label: "سازمان صادرکننده", type: "text" },
      { name: "issueDate", label: "تاریخ صدور", type: "text" },
      { name: "credentialId", label: "شناسه مدرک", type: "text" },
      { name: "credentialUrl", label: "لینک اعتبارسنجی", type: "text" },
      { name: "description", label: "توضیحات", type: "textarea" },
      { name: "image", label: "تصویر مدرک", type: "media" },
    ],
  },
  {
    key: "buttons",
    title: "دکمه‌ها",
    singular: "دکمه",
    icon: "MousePointerClick",
    labelField: "label",
    columns: ["label", "location", "style"],
    fields: [
      { name: "label", label: "متن دکمه", type: "text", required: true },
      { name: "key", label: "کلید یکتا", type: "text" },
      { name: "icon", label: "آیکون", type: "icon" },
      { name: "url", label: "لینک", type: "text" },
      { name: "style", label: "استایل", type: "select", options: [
        { value: "primary", label: "اصلی" },
        { value: "glass", label: "شیشه‌ای" },
      ], default: "glass" },
      { name: "target", label: "نحوه باز شدن", type: "select", options: [
        { value: "_self", label: "همین صفحه" },
        { value: "_blank", label: "صفحه جدید" },
      ], default: "_self" },
      { name: "location", label: "موقعیت", type: "text", default: "hero" },
    ],
  },
];
